import '@oneclick/react-lemonade-editor/dist/index.css';
import '@oneclick/react-mint-editor/dist/style.css';
import '@oneclick/react-videolesson/dist/style.css';
import 'prismjs/themes/prism.css'; // Example style, you can use another
import 'rc-dialog/assets/index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Toaster } from 'react-hot-toast';
import 'react-toggle/style.css'; // for ES6 modules
import App from './App';
import './index.scss';
import { initMetrics, setUser } from './utils/metrics';

ReactDOM.render(
  <React.StrictMode>
    <App />
    <Toaster />
  </React.StrictMode>,
  document.getElementById('root')
);

initMetrics();
setUser('test-lemontree');

console.log(`${process.env.REACT_APP_WEBSITE_NAME} v${process.env.REACT_APP_VERSION} - 10/02/2026`);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
